import * as React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { BulkReportingAccessSummaryItem } from '../../../components/common/summary-item/BulkReportingAccessSummaryItem';
import { ISummaryItem } from '../../../models';
import PermissionConstants from '../../../permissionConstants';
import { IApplicationState } from '../../../store';
import { IUserFeatureAccessHelper, UserFeatureAccessHelper } from '../../../utilities/FeatureFlags';
import { ClearDiv, Col3Col9, ListSummaryItem, PlainTextSummaryItem, ReportingUsersSummaryItem } from '../../common';
import { Permission } from '@aon/aon-tws-common-ui';

export interface IReportingLayoutProps extends ISummaryItem {
	userFeatureAccessHelper: IUserFeatureAccessHelper;
}

export enum ReportingSummaryItemType {
	SelectedTrendGroupId = 'SelectedTrendGroupId',
	EnableLiveResponses = 'EnableLiveResponses',
	MinN = 'MinN',
	ReportingUsers = 'ReportingUsers',
	ParticipationMonitorAttributes = 'ParticipationMonitorAttributes',
	ParticipationMonitorHierarchies = 'ParticipationMonitorHierarchies',
	BulkReportingAccess = 'BulkReportingAccess',
}

export const ReportingLayoutWrapper = styled.div``;

export class ReportingLayout extends React.Component<IReportingLayoutProps> {
	public render() {
		const { displayName, value, userFeatureAccessHelper } = this.props;
		const reportingSummaryItems = value as ISummaryItem[];

		return (
			<ReportingLayoutWrapper>
				<ClearDiv clearHeight='64px' />
				<Col3Col9 labelSize='lg' label={displayName} />
				{reportingSummaryItems !== undefined &&
					reportingSummaryItems.map((item: ISummaryItem, key) => {
						switch (item.propertyName) {
							case ReportingSummaryItemType.SelectedTrendGroupId:
							case ReportingSummaryItemType.EnableLiveResponses:
							case ReportingSummaryItemType.MinN:
								return <PlainTextSummaryItem {...item} key={key} />;
							case ReportingSummaryItemType.ReportingUsers:
								return <ReportingUsersSummaryItem {...item} key={key} />;
							case ReportingSummaryItemType.ParticipationMonitorAttributes:
								return <ListSummaryItem {...item} key={key} />;
							case ReportingSummaryItemType.ParticipationMonitorHierarchies:
								return <ListSummaryItem {...item} key={key} />;
							case ReportingSummaryItemType.BulkReportingAccess:
								if (userFeatureAccessHelper.CanUserAccessFeature('EnableReportingBulkUsers')) {
									return (
										<Permission {...PermissionConstants.HIERARCHYREPORTING_ALL}>
											<BulkReportingAccessSummaryItem {...item} key={key} />
										</Permission>
									);
								}
								return null;
						}
					})}
			</ReportingLayoutWrapper>
		);
	}
}

export const ReportingLayoutContainer = connect((state: IApplicationState) => ({
	userFeatureAccessHelper: new UserFeatureAccessHelper(state.oidc.user),
}))(ReportingLayout);
